import { render, staticRenderFns } from "./CircleArrows.vue?vue&type=template&id=2d247717&scoped=true"
import script from "./CircleArrows.vue?vue&type=script&lang=js"
export * from "./CircleArrows.vue?vue&type=script&lang=js"
import style0 from "./CircleArrows.vue?vue&type=style&index=0&id=2d247717&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d247717",
  null
  
)

export default component.exports